import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FaBusinessTime,
  FaProjectDiagram,
  FaHandshake,
} from "react-icons/fa";

import { HiArrowRight } from "react-icons/hi2";


import HeroSection from "../components/HeroSection";
import PresenceSection from "../components/PresenceSection";
import CourseCard from "../components/CourseCard";
import ServiceCard from "../components/ServiceCard";
import PlacementLogoGrid from "../components/PlacementLogoGrid";
// import PopupForm from "../components/PopupForm";
import PlacementSuccessSection from "../components/PlacementSuccessSection";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import courses from "../data/courses";
import services from "../data/services";


const trendingCourseOrder = [
  "Data Analytics",
  "Full Stack Development",
  "Generative AI",
  "AI-Powered Digital Marketing",
  "DevOps",
  "Placement Training",
  "HR Training & Office Automation",
];

const trendingCourses = trendingCourseOrder
  .map((title) =>
    courses.find(
      (course) =>
        course.showOnHome && course.title === title
    )
  )
  .filter(Boolean);

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <HeroSection />

      {/* Presence Section */}
      <PresenceSection />

      {/* Courses Section */}
      <section
        aria-labelledby="courses-section-heading"
        className="
    container
    relative
    mx-auto
    px-4
    py-8
    sm:py-10
  "
      >
        {/* Subtle background accents */}
        <div
          aria-hidden="true"
          className="
      pointer-events-none
      absolute
      left-1/2
      top-8
      -z-10
      h-32
      w-32
      -translate-x-1/2
      rounded-full
      bg-indigo-500/10
      blur-3xl
      dark:bg-indigo-500/10
    "
        />

        <div
          aria-hidden="true"
          className="
      pointer-events-none
      absolute
      right-0
      top-1/2
      -z-10
      h-48
      w-48
      rounded-full
      bg-blue-500/5
      blur-3xl
      dark:bg-blue-500/5
    "
        />

        {/* Section Header */}
        <motion.header
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          viewport={{
            once: true,
            margin: "0px 0px -40px 0px",
          }}
          className="
      relative
      mx-auto
      mb-8
      max-w-3xl
      text-center
    "
        >
          {/* Eyebrow */}
          <div
            className="
        mb-2.5
        inline-flex
        items-center
        gap-2
        rounded-full
        border
        border-indigo-100
        bg-indigo-50/80
        px-3
        py-1.5
        text-[10px]
        font-bold
        uppercase
        tracking-[0.14em]
        text-indigo-700
        shadow-sm
        dark:border-indigo-900/60
        dark:bg-indigo-950/40
        dark:text-indigo-300
        dark:shadow-none
        sm:text-[11px]
      "
          >
            <span
              aria-hidden="true"
              className="
          h-1.5
          w-1.5
          rounded-full
          bg-indigo-500
          shadow-[0_0_8px_rgba(99,102,241,0.55)]
        "
            />

            <span>Career-Focused IT Training</span>
          </div>

          {/* Main Heading */}
          <h2
            id="courses-section-heading"
            className="
        text-[1.7rem]
        font-extrabold
        leading-[1.15]
        tracking-[-0.03em]
        text-gray-950
        dark:text-white
        sm:text-3xl
        md:text-[2.25rem]
      "
          >
            <span
              className="
          bg-gradient-to-r
          from-indigo-700
          via-blue-600
          to-cyan-500
          bg-clip-text
          text-transparent
        "
            >
              IT Courses & Professional Training in Tirupati
            </span>
          </h2>

          {/* Accent */}
          <div
            aria-hidden="true"
            className="
        mx-auto
        mt-3
        h-1
        w-10
        rounded-full
        bg-gradient-to-r
        from-indigo-600
        to-cyan-500
      "
          />

          {/* Description */}
          <p
            className="
        mx-auto
        mt-3
        max-w-2xl
        px-2
        text-[13px]
        leading-6
        text-gray-600
        dark:text-gray-300
        sm:text-sm
        sm:leading-6
      "
          >
            Explore practical IT courses and professional training in Tirupati for
            students, graduates, job seekers, and working professionals. Build
            in-demand skills through hands-on learning, projects, and
            career-focused training.
          </p>
        </motion.header>

        {/* Courses Grid */}
        <div
          className="
      grid
      grid-cols-1
      gap-6
      sm:grid-cols-2
      md:grid-cols-3
      lg:grid-cols-4
    "
        >
          {trendingCourses.map((course, index) => (
            <motion.div
              key={course.slug}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{
                once: true,
                margin: "0px 0px -40px 0px",
              }}
              transition={{
                delay: index * 0.05,
                duration: 0.4,
                ease: "easeOut",
              }}
            >
              <CourseCard
                title={course.title}
                slug={course.slug}
                icon={course.icon}
                category={course.category}
                description={course.description}
                rating={course.rating}
                students={course.students}
                level={course.level}
                label={course.label}
              />
            </motion.div>
          ))}
        </div>

        {/* View All Courses */}
        <div className="mt-7 flex justify-center">
          <Link
            to="/courses"
            className="
        group
        inline-flex
        items-center
        gap-2
        rounded-xl
        border
        border-gray-200
        bg-white
        px-5
        py-2.5
        text-xs
        font-bold
        text-gray-800
        shadow-sm
        transition-all
        duration-300
        hover:-translate-y-0.5
        hover:border-indigo-200
        hover:bg-indigo-50
        hover:text-indigo-700
        hover:shadow-md
        focus:outline-none
        focus-visible:ring-2
        focus-visible:ring-indigo-500
        focus-visible:ring-offset-2
        dark:border-gray-700
        dark:bg-gray-900
        dark:text-gray-100
        dark:hover:border-indigo-700
        dark:hover:bg-indigo-950/40
        dark:hover:text-indigo-300
        dark:focus-visible:ring-offset-gray-900
      "
          >
            <span>View All Courses</span>

            <span
              aria-hidden="true"
              className="
          flex
          h-6
          w-6
          items-center
          justify-center
          rounded-full
          bg-gray-100
          text-gray-500
          transition-all
          duration-300
          group-hover:translate-x-0.5
          group-hover:bg-indigo-100
          group-hover:text-indigo-600
          dark:bg-gray-800
          dark:text-gray-400
          dark:group-hover:bg-indigo-900/50
          dark:group-hover:text-indigo-300
        "
            >
              <HiArrowRight className="text-[11px]" />
            </span>
          </Link>
        </div>
      </section>

      {/* Why Choose IA4Solutions */}
      <section
        aria-labelledby="why-choose-us-heading"
        className="
    relative
    overflow-hidden
    bg-white
    py-9
    dark:bg-gray-950
    sm:py-11
    md:py-12
  "
      >
        {/* Ambient background */}
        <div
          aria-hidden="true"
          className="
      pointer-events-none
      absolute
      left-1/2
      top-0
      h-72
      w-72
      -translate-x-1/2
      rounded-full
      bg-indigo-500/[0.045]
      blur-3xl
      dark:bg-indigo-500/[0.08]
    "
        />

        <div
          aria-hidden="true"
          className="
      pointer-events-none
      absolute
      left-0
      top-1/2
      h-56
      w-56
      -translate-y-1/2
      rounded-full
      bg-blue-500/[0.025]
      blur-3xl
      dark:bg-blue-500/[0.04]
    "
        />

        <div
          aria-hidden="true"
          className="
      pointer-events-none
      absolute
      bottom-0
      right-0
      h-64
      w-64
      rounded-full
      bg-purple-500/[0.025]
      blur-3xl
      dark:bg-purple-500/[0.05]
    "
        />

        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6">

          {/* =========================
        HEADER
       ========================= */}
          <motion.header
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{
              once: true,
              margin: "0px 0px -40px 0px",
            }}
            transition={{
              duration: 0.45,
              ease: "easeOut",
            }}
            className="
        mx-auto
        mb-7
        max-w-3xl
        text-center
        sm:mb-8
      "
          >
            {/* Eyebrow */}
            <div
              className="
          mb-2.5
          inline-flex
          items-center
          gap-2
          rounded-full
          border
          border-gray-200/80
          bg-white/80
          px-3
          py-1.5
          text-[10px]
          font-bold
          uppercase
          tracking-[0.15em]
          text-gray-600
          shadow-sm
          backdrop-blur-sm
          dark:border-gray-800
          dark:bg-gray-900/80
          dark:text-gray-300
        "
            >
              <span
                aria-hidden="true"
                className="
            h-1.5
            w-1.5
            rounded-full
            bg-gradient-to-r
            from-indigo-500
            to-cyan-500
          "
              />

              Why IA4Solutions
            </div>

            {/* Heading */}
            <h2
              id="why-choose-us-heading"
              className="
          text-[1.75rem]
          font-extrabold
          leading-[1.12]
          tracking-[-0.035em]
          text-gray-950
          dark:text-white
          sm:text-3xl
          md:text-[2.25rem]
        "
            >
              Learn. Build.{" "}
              <span
                className="
            bg-gradient-to-r
            from-indigo-600
            via-blue-600
            to-cyan-500
            bg-clip-text
            text-transparent
          "
              >
                Grow.
              </span>
            </h2>

            {/* Accent */}
            <div
              aria-hidden="true"
              className="
          mx-auto
          mt-3
          h-[3px]
          w-10
          rounded-full
          bg-gradient-to-r
          from-indigo-600
          to-cyan-500
        "
            />

            {/* Description */}
            <p
              className="
          mx-auto
          mt-3
          max-w-2xl
          text-[13px]
          leading-6
          text-gray-600
          dark:text-gray-300
          sm:text-sm
        "
            >
              Develop practical technology skills through structured training,
              hands-on projects, and career-focused learning.
            </p>
          </motion.header>

          {/* =========================
        FEATURE CARDS
       ========================= */}
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">

            {/* =======================
          CARD 1
         ======================= */}
            <motion.article
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{
                once: true,
                margin: "0px 0px -30px 0px",
              }}
              transition={{
                duration: 0.45,
                ease: "easeOut",
              }}
              whileHover={{ y: -4 }}
              className="
          group
          relative
          overflow-hidden
          rounded-[20px]
          border
          border-gray-200/80
          bg-white
          p-5
          shadow-[0_6px_24px_rgba(15,23,42,0.055)]
          transition-all
          duration-300
          hover:border-indigo-200
          hover:shadow-[0_16px_36px_rgba(15,23,42,0.09)]
          dark:border-gray-800
          dark:bg-gray-900
          dark:hover:border-indigo-800
          dark:hover:shadow-[0_16px_36px_rgba(0,0,0,0.24)]
        "
            >
              {/* Accent */}
              <div
                aria-hidden="true"
                className="
            absolute
            inset-x-0
            top-0
            h-[2px]
            bg-gradient-to-r
            from-indigo-500
            via-blue-500
            to-cyan-400
            opacity-80
          "
              />

              <div className="flex items-start gap-4">

                {/* Icon */}
                <div
                  className="
              relative
              flex
              h-12
              w-12
              shrink-0
              items-center
              justify-center
              rounded-[14px]
              border
              border-indigo-100
              bg-gradient-to-br
              from-indigo-50
              to-blue-50
              text-indigo-600
              shadow-sm
              transition-all
              duration-300
              group-hover:scale-[1.05]
              group-hover:shadow-md
              dark:border-indigo-900/60
              dark:from-indigo-950/50
              dark:to-blue-950/40
              dark:text-indigo-300
            "
                >
                  <FaBusinessTime
                    aria-hidden="true"
                    className="relative z-10 text-xl"
                  />
                </div>

                <div className="min-w-0 flex-1">

                  {/* Small label */}
                  <p
                    className="
                mb-1
                text-[9px]
                font-bold
                uppercase
                tracking-[0.14em]
                text-indigo-600
                dark:text-indigo-400
              "
                  >
                    Learn
                  </p>

                  <h3
                    className="
                text-[17px]
                font-bold
                leading-snug
                tracking-[-0.015em]
                text-gray-900
                dark:text-white
              "
                  >
                    Professional Training
                  </h3>

                  <p
                    className="
                mt-1.5
                text-[12px]
                leading-5.5
                text-gray-600
                dark:text-gray-300
              "
                  >
                    Structured programs focused on practical technology skills,
                    tools, and real-world applications.
                  </p>

                </div>
              </div>

              {/* Bottom micro indicator */}
              <div
                className="
            mt-4
            flex
            items-center
            gap-2
            text-[10px]
            font-semibold
            text-gray-500
            dark:text-gray-400
          "
              >
                <span
                  aria-hidden="true"
                  className="
              h-1
              w-5
              rounded-full
              bg-indigo-500/70
              transition-all
              duration-300
              group-hover:w-8
            "
                />

                Practical skill development
              </div>
            </motion.article>

            {/* =======================
          CARD 2
         ======================= */}
            <motion.article
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{
                once: true,
                margin: "0px 0px -30px 0px",
              }}
              transition={{
                delay: 0.07,
                duration: 0.45,
                ease: "easeOut",
              }}
              whileHover={{ y: -4 }}
              className="
          group
          relative
          overflow-hidden
          rounded-[20px]
          border
          border-gray-200/80
          bg-white
          p-5
          shadow-[0_6px_24px_rgba(15,23,42,0.055)]
          transition-all
          duration-300
          hover:border-purple-200
          hover:shadow-[0_16px_36px_rgba(15,23,42,0.09)]
          dark:border-gray-800
          dark:bg-gray-900
          dark:hover:border-purple-800
          dark:hover:shadow-[0_16px_36px_rgba(0,0,0,0.24)]
        "
            >
              {/* Accent */}
              <div
                aria-hidden="true"
                className="
            absolute
            inset-x-0
            top-0
            h-[2px]
            bg-gradient-to-r
            from-purple-500
            via-fuchsia-500
            to-pink-500
            opacity-80
          "
              />

              <div className="flex items-start gap-4">

                {/* Icon */}
                <div
                  className="
              relative
              flex
              h-12
              w-12
              shrink-0
              items-center
              justify-center
              rounded-[14px]
              border
              border-purple-100
              bg-gradient-to-br
              from-purple-50
              to-fuchsia-50
              text-purple-600
              shadow-sm
              transition-all
              duration-300
              group-hover:scale-[1.05]
              group-hover:shadow-md
              dark:border-purple-900/60
              dark:from-purple-950/50
              dark:to-fuchsia-950/40
              dark:text-purple-300
            "
                >
                  <FaProjectDiagram
                    aria-hidden="true"
                    className="relative z-10 text-xl"
                  />
                </div>

                <div className="min-w-0 flex-1">

                  <p
                    className="
                mb-1
                text-[9px]
                font-bold
                uppercase
                tracking-[0.14em]
                text-purple-600
                dark:text-purple-400
              "
                  >
                    Build
                  </p>

                  <h3
                    className="
                text-[17px]
                font-bold
                leading-snug
                tracking-[-0.015em]
                text-gray-900
                dark:text-white
              "
                  >
                    Project-Based Learning
                  </h3>

                  <p
                    className="
                mt-1.5
                text-[12px]
                leading-5.5
                text-gray-600
                dark:text-gray-300
              "
                  >
                    Apply concepts through hands-on projects that strengthen
                    problem-solving and implementation skills.
                  </p>

                </div>
              </div>

              <div
                className="
            mt-4
            flex
            items-center
            gap-2
            text-[10px]
            font-semibold
            text-gray-500
            dark:text-gray-400
          "
              >
                <span
                  aria-hidden="true"
                  className="
              h-1
              w-5
              rounded-full
              bg-purple-500/70
              transition-all
              duration-300
              group-hover:w-8
            "
                />

                Learn by building
              </div>
            </motion.article>

            {/* =======================
          CARD 3
         ======================= */}
            <motion.article
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{
                once: true,
                margin: "0px 0px -30px 0px",
              }}
              transition={{
                delay: 0.14,
                duration: 0.45,
                ease: "easeOut",
              }}
              whileHover={{ y: -4 }}
              className="
          group
          relative
          overflow-hidden
          rounded-[20px]
          border
          border-gray-200/80
          bg-white
          p-5
          shadow-[0_6px_24px_rgba(15,23,42,0.055)]
          transition-all
          duration-300
          hover:border-emerald-200
          hover:shadow-[0_16px_36px_rgba(15,23,42,0.09)]
          dark:border-gray-800
          dark:bg-gray-900
          dark:hover:border-emerald-800
          dark:hover:shadow-[0_16px_36px_rgba(0,0,0,0.24)]
        "
            >
              {/* Accent */}
              <div
                aria-hidden="true"
                className="
            absolute
            inset-x-0
            top-0
            h-[2px]
            bg-gradient-to-r
            from-emerald-500
            via-teal-500
            to-cyan-500
            opacity-80
          "
              />

              <div className="flex items-start gap-4">

                {/* Icon */}
                <div
                  className="
              relative
              flex
              h-12
              w-12
              shrink-0
              items-center
              justify-center
              rounded-[14px]
              border
              border-emerald-100
              bg-gradient-to-br
              from-emerald-50
              to-teal-50
              text-emerald-600
              shadow-sm
              transition-all
              duration-300
              group-hover:scale-[1.05]
              group-hover:shadow-md
              dark:border-emerald-900/60
              dark:from-emerald-950/50
              dark:to-teal-950/40
              dark:text-emerald-300
            "
                >
                  <FaHandshake
                    aria-hidden="true"
                    className="relative z-10 text-xl"
                  />
                </div>

                <div className="min-w-0 flex-1">

                  <p
                    className="
                mb-1
                text-[9px]
                font-bold
                uppercase
                tracking-[0.14em]
                text-emerald-600
                dark:text-emerald-400
              "
                  >
                    Grow
                  </p>

                  <h3
                    className="
                text-[17px]
                font-bold
                leading-snug
                tracking-[-0.015em]
                text-gray-900
                dark:text-white
              "
                  >
                    Career & Placement Support
                  </h3>

                  <p
                    className="
                mt-1.5
                text-[12px]
                leading-5.5
                text-gray-600
                dark:text-gray-300
              "
                  >
                    Support for career preparation, interview readiness,
                    and professional development.
                  </p>

                </div>
              </div>

              <div
                className="
            mt-4
            flex
            items-center
            gap-2
            text-[10px]
            font-semibold
            text-gray-500
            dark:text-gray-400
          "
              >
                <span
                  aria-hidden="true"
                  className="
              h-1
              w-5
              rounded-full
              bg-emerald-500/70
              transition-all
              duration-300
              group-hover:w-8
            "
                />

                Prepare for the next step
              </div>
            </motion.article>
          </div>

          {/* =========================
        TRUST STRIP
       ========================= */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.25,
              duration: 0.4,
            }}
            className="
        mx-auto
        mt-6
        flex
        max-w-4xl
        flex-wrap
        items-center
        justify-center
        gap-x-5
        gap-y-2
        text-center
      "
          >
            <span
              className="
          text-[10px]
          font-semibold
          text-gray-500
          dark:text-gray-400
        "
            >
              Practical Learning
            </span>

            <span
              aria-hidden="true"
              className="hidden h-3 w-px bg-gray-200 dark:bg-gray-800 sm:block"
            />

            <span
              className="
          text-[10px]
          font-semibold
          text-gray-500
          dark:text-gray-400
        "
            >
              Industry-Relevant Skills
            </span>

            <span
              aria-hidden="true"
              className="hidden h-3 w-px bg-gray-200 dark:bg-gray-800 sm:block"
            />

            <span
              className="
          text-[10px]
          font-semibold
          text-gray-500
          dark:text-gray-400
        "
            >
              Career Development
            </span>
          </motion.div>

        </div>
      </section>
      {/* Services Section */}
      <section
        aria-labelledby="services-section-heading"
        className="
    relative
    overflow-hidden
    bg-gray-50/70
    py-9
    dark:bg-gray-950
    sm:py-11
    md:py-12
  "
      >
        {/* Subtle background */}
        <div
          aria-hidden="true"
          className="
      pointer-events-none
      absolute
      left-1/2
      top-0
      h-72
      w-72
      -translate-x-1/2
      rounded-full
      bg-indigo-500/[0.045]
      blur-3xl
      dark:bg-indigo-500/[0.08]
    "
        />

        <div
          className="
      relative
      z-10
      mx-auto
      max-w-7xl
      px-4
      sm:px-6
    "
        >

          {/* Section Header */}
          <motion.header
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{
              once: true,
              margin: "0px 0px -40px 0px",
            }}
            transition={{
              duration: 0.45,
              ease: "easeOut",
            }}
            className="
        mx-auto
        mb-7
        max-w-3xl
        text-center
        sm:mb-8
      "
          >

            {/* Eyebrow */}
            <div
              className="
          mb-2.5
          inline-flex
          items-center
          gap-2
          rounded-full
          border
          border-gray-200
          bg-white/80
          px-3
          py-1.5
          text-[10px]
          font-bold
          uppercase
          tracking-[0.15em]
          text-gray-600
          shadow-sm
          backdrop-blur-sm
          dark:border-gray-800
          dark:bg-gray-900/80
          dark:text-gray-300
        "
            >
              <span
                aria-hidden="true"
                className="
            h-1.5
            w-1.5
            rounded-full
            bg-gradient-to-r
            from-indigo-500
            to-cyan-500
          "
              />

              What We Offer
            </div>

            {/* Heading */}
            <h2
              id="services-section-heading"
              className="
          text-[1.75rem]
          font-extrabold
          leading-[1.12]
          tracking-[-0.035em]
          text-gray-950
          dark:text-white
          sm:text-3xl
          md:text-[2.3rem]
        "
            >
              IT, Career & Digital Services{" "}
              <span
                className="
            bg-gradient-to-r
            from-indigo-600
            via-blue-600
            to-cyan-500
            bg-clip-text
            text-transparent
          "
              >
                in Tirupati
              </span>
            </h2>

            {/* Accent */}
            <div
              aria-hidden="true"
              className="
          mx-auto
          mt-3
          h-[3px]
          w-10
          rounded-full
          bg-gradient-to-r
          from-indigo-600
          to-cyan-500
        "
            />

            {/* Description */}
            <p
              className="
          mx-auto
          mt-3
          max-w-2xl
          text-[13px]
          leading-6
          text-gray-600
          dark:text-gray-300
          sm:text-sm
        "
            >
              From career preparation and internships to IT training,
              academic projects, website development, and digital marketing,
              explore practical services for students, professionals,
              institutions, and businesses.
            </p>
          </motion.header>

          {/* Services Grid */}
          <div
            className="
        grid
        grid-cols-1
        gap-4
        sm:grid-cols-2
        lg:grid-cols-3
      "
          >
            {services
              .filter((service) => service.showOnHome)
              .map((service, index) => (
                <ServiceCard
                  key={service.slug}
                  title={service.title}
                  icon={service.icon}
                  description={service.description}
                  gradient={service.gradient}
                  index={index}
                />
              ))}
          </div>

          {/* Bottom CTA */}
          <div className="mt-7 flex justify-center">
            <Link
              to="/services"
              className="
          group
          inline-flex
          items-center
          gap-2
          rounded-xl
          border
          border-gray-200
          bg-white
          px-5
          py-2.5
          text-xs
          font-bold
          text-gray-800
          shadow-sm
          transition-all
          duration-300
          hover:-translate-y-0.5
          hover:border-indigo-200
          hover:bg-indigo-50
          hover:text-indigo-700
          hover:shadow-md
          focus:outline-none
          focus-visible:ring-2
          focus-visible:ring-indigo-500
          focus-visible:ring-offset-2
          dark:border-gray-700
          dark:bg-gray-900
          dark:text-gray-100
          dark:hover:border-indigo-700
          dark:hover:bg-indigo-950/40
          dark:hover:text-indigo-300
          dark:focus-visible:ring-offset-gray-950
        "
            >
              <span>Explore All Services</span>

              <span
                aria-hidden="true"
                className="
            flex
            h-6
            w-6
            items-center
            justify-center
            rounded-full
            bg-gray-100
            text-gray-500
            transition-all
            duration-300
            group-hover:translate-x-0.5
            group-hover:bg-indigo-100
            group-hover:text-indigo-600
            dark:bg-gray-800
            dark:text-gray-400
            dark:group-hover:bg-indigo-900/50
            dark:group-hover:text-indigo-300
          "
              >
                <HiArrowRight className="text-[11px]" />
              </span>
            </Link>
          </div>

        </div>
      </section>


      {/* Placement Success */}
      <PlacementSuccessSection />


      {/* Placements Section */}
      <section className="relative bg-gradient-to-b from-white dark:from-gray-900 via-gray-50 dark:via-gray-800 to-white dark:to-gray-900 py-6 md:py-8 overflow-hidden">
        {/* Background Blobs */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 left-1/4 w-72 h-72 rounded-full bg-blue-100/30 dark:bg-blue-700/30 blur-3xl animate-pulse-slow"></div>
          <div className="absolute bottom-20 right-1/4 w-96 h-96 rounded-full bg-pink-100/20 dark:bg-pink-700/20 blur-3xl animate-spin-slow"></div>
          <div className="absolute top-1/2 left-1/2 w-80 h-80 rounded-full bg-purple-100/20 dark:bg-purple-700/20 blur-2xl -translate-x-1/2 -translate-y-1/2 animate-pulse-slow"></div>
          <div className="absolute top-1/3 right-1/3 w-20 h-20 rounded-full bg-indigo-200/30 dark:bg-indigo-700/30 blur-xl animate-bounce-slow"></div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative z-20 container mx-auto px-3 text-center"
        >
          {/* Heading */}
          <h2 className="relative text-3xl md:text-5xl font-bold text-sky-900 leading-snug inline-block drop-shadow-md">
            Our{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 via-cyan-500 to-blue-600">
              Candidates are
            </span>{" "}
            Working in {" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-indigo-500">
              reputed MNC's
            </span>

            {/* Centered Underline */}
            <span className="absolute left-1/2 -bottom-3 w-36 h-1 bg-gradient-to-r from-teal-400 via-purple-400 to-indigo-500 rounded-full opacity-90 -translate-x-1/2 shadow-md"></span>
          </h2>



          {/* Paragraph */}
          <p className="text-gray-700 dark:text-gray-300 mt-4 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">

            Empowering talent with <span className="font-semibold text-pink-500">industry-ready skills</span>, hands-on{" "}
            <span className="font-semibold text-purple-500">project experience</span>, and opportunities to work with <span className="font-semibold text-indigo-600 dark:text-indigo-400">top global MNCs</span> for real-world success.
          </p>

        </motion.div>

        {/* Logo Grid */}
        <div className="relative z-20 max-w-6xl mx-auto mt-6">
          <PlacementLogoGrid />
        </div>

        {/* Bottom Gradient Fade */}
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-gray-50 dark:from-gray-900 to-transparent"></div>
      </section>



      {/* CTA Section */}
      <section className="relative bg-gradient-to-r from-gray-100 dark:from-gray-900 to-gray-200 dark:to-gray-800 py-8 md:py-12 overflow-hidden">
        <div className="container mx-auto px-6">
          <div className="relative bg-white dark:bg-gray-800 shadow-2xl rounded-3xl p-12 md:p-24 text-center overflow-hidden">

            {/* Background Shapes */}
            <div className="absolute top-0 left-0 w-40 h-40 rounded-full bg-blue-200/40 dark:bg-blue-700/30 blur-3xl animate-spin-slow -translate-x-12 -translate-y-12 pointer-events-none"></div>
            <div className="absolute bottom-0 right-0 w-56 h-56 rounded-full bg-pink-200/40 dark:bg-pink-700/30 blur-3xl animate-pulse-slow translate-x-16 translate-y-12 pointer-events-none"></div>
            <div className="absolute top-1/2 left-1/2 w-80 h-80 rounded-full bg-gradient-to-r from-purple-100/30 dark:from-purple-700/30 to-indigo-100/30 dark:to-indigo-800/30 blur-2xl -translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>

            {/* Heading */}
            <motion.h3
              initial={{ y: 40, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="relative z-20 text-2xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 mb-6 inline-block"
            >
              Elevate Your Career to the Next Level
              {/* Centered Underline */}
              <span className="absolute left-1/2 -bottom-2 w-32 h-1 bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400 rounded-full opacity-90 -translate-x-1/2"></span>
            </motion.h3>


            {/* Paragraph */}
            <motion.p
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.7 }}
              className="text-gray-800 dark:text-gray-200 text-base md:text-lg mb-12 max-w-3xl mx-auto leading-relaxed relative z-10"
            >
              Join{" "}
              <span className="font-semibold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 via-teal-400 to-indigo-500">
                ia4solutions
              </span>{" "}
              and gain <span className="font-semibold text-pink-500">industry-ready skills</span>, hands-on{" "}
              <span className="font-semibold text-purple-500">project experience</span>, and opportunities with top global MNCs. Transform your knowledge into a rewarding career guided by{" "}
              <span className="font-semibold text-indigo-500 dark:text-indigo-400">industry experts</span>.
            </motion.p>

            {/* Button */}
            <motion.a
              href="/register"
              whileHover={{ scale: 1.1, y: -2 }}
              whileTap={{ scale: 0.95 }}
              className="relative z-10 inline-block 
             bg-gradient-to-r from-pink-500 via-purple-600 to-indigo-500 
             dark:from-pink-600 dark:via-purple-700 dark:to-indigo-600
             text-white font-bold text-lg md:text-xl
             px-12 py-4 rounded-3xl
             shadow-lg shadow-pink-400/40 dark:shadow-indigo-900/50
             hover:shadow-xl hover:shadow-pink-500/60 dark:hover:shadow-indigo-700/60
             transition-all duration-300 ease-in-out
             ring-2 ring-transparent hover:ring-pink-300 dark:hover:ring-indigo-400"
            >
              Get Started
              {/* Optional animated spark */}
              <span className="absolute -top-2 -right-2 w-3 h-3 bg-white rounded-full opacity-70 animate-pulse"></span>
            </motion.a>



            {/* Overlay Blur */}
            <div className="absolute inset-0 bg-white/5 dark:bg-gray-700/20 backdrop-blur-sm pointer-events-none rounded-3xl"></div>
          </div>
        </div>

        {/* Floating Bubbles */}
        <div className="absolute top-0 left-1/4 w-2 h-2 rounded-full bg-blue-300/60 blur-sm animate-bounce-slow"></div>
        <div className="absolute bottom-1/4 right-1/3 w-3 h-3 rounded-full bg-pink-300/50 blur-sm animate-bounce-slow delay-1500"></div>
      </section>
      {/* <PopupForm /> 👈 add this at the end */}

    </>
  );
};

export default Home;
